export const ru = {
    'feed-required': 'Нужно сохранить фид',
    'general-rate-max-price': 'Максимальная ставка не должна быть больше {maxValue} {currency}',
    'general-rate-min-price': 'Максимальная ставка не должна быть меньше {minValue} {currency}',
    'name-empty': 'Не указано название группы'
};
